// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::-webkit-scrollbar-track {
  background: #323e4a;
}

::-webkit-scrollbar-thumb {
  background: #1C2A39;
}

.sidebar-menu-item:hover a i {
  filter: brightness(158%) sepia(0) hue-rotate(0) saturate(0);
}

.sidebar-menu-item:hover a span.right-nav-text {
  color: rgb(235, 235, 235);
}

.profile-dropdown {
  width: 216px;
  position: absolute;
  left: -64px;
  background: #fff;
  border: #D1D3DB solid 1px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);
  top: 47px;
  border-radius: 0;
  right: 0;
  margin: 0;
}

.profile-dropdown .name-box h4 {
  font-size: 16px;
  white-space: nowrap;
  max-width: 107px;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: 600;
  color: #43425D;
  display: inline-block;
  margin-bottom: 6px;
  text-decoration: underline;
  line-height: 20px;
}

.profile-dropdown .user-info, .profile-dropdown .user-link-box {
  padding: 15px;
  border-bottom: #EBEBF2 solid 1px;
}

.dropdown.user-auth {
  border-left: none;
}

.profile-dropdown .btn.view {
  border: #EBEBF2 solid 1px;
  width: 90px;
  height: 28px;
  border-radius: 0;
  font-size: 12px;
  line-height: 28px;
  padding: 0;
}

.profile-dropdown .btn.view:focus {
  outline: none;
}

.dropdown.user-auth > a {
  text-decoration: none;
}

.dropdown.user-auth .user-right-name > label {
  margin: 0;
  cursor: pointer;
  font-size: 16px;
  text-decoration: underline;
}

.dropdown.user-auth .user-right-name > .impressonate {
  font-size: 12px;
  line-height: 12px;
  color: #4D4F5C;
  text-decoration: none;
  font-weight: 600;
}

.dropdown.user-auth .user-right-name > .impressonate > label {
  text-decoration: underline;
  color: #4296F7;
  font-size: 12px;
  display: inline-block;
  margin: 0;
}

.profile-dropdown .btn.view .fa.fa-chevron-right {
  font-size: 10px;
  color: #A4AFB7;
  margin: 0 0 0 2px;
}

.profile-dropdown .user-link-box {
  padding: 15px 0;
}

.drop-iner-wrap {
  position: relative;
}

.profile-dropdown:before {
  position: absolute;
  left: 44%;
  top: -11px;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 12px solid #fff;
  content: "";
  z-index: 9
}

.profile-dropdown:after {
  position: absolute;
  left: 44%;
  top: -13px;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 12px solid #D1D3DB;
  content: "";
  z-index: 1
}

/*******dropdown pic**********/
.profile-dropdown.dropdown-menu .dropdow-notification {
  padding: 15px 0;
  border-bottom: #EBEBF2 solid 1px;
}

.dropdown.user-auth .profile-drop-pic.top {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: #8C96A0 solid 3px;
  overflow: hidden;
  margin: 10px 5px 5px;
}

.dropdown.user-auth .profile-drop-pic.top > img {
  width: 100%;
  height: 100%;
  max-width: 100%;
}

.dropdown.user-auth .profile-dropdown .profile-drop-pic {
  width: 47px;
  height: 47px;
  border-radius: 50%;
  border: #8C96A0 solid 4px;
  overflow: hidden;
  margin-top: 5px;
}

.dropdown.user-auth .profile-dropdown .profile-drop-pic img {
  width: 100%;
  height: 100%;
  max-width: 100%;
}

/*******dropdown pic**********/

.profile-dropdown .user-link-box ul li, .profile-dropdown.dropdown-menu .dropdow-notification ul.notification li {
  width: 100%;
  padding: 0;
  margin: 0;
  text-align: left;
  height: auto;
}

.profile-dropdown .user-link-box ul li a, .profile-dropdown.dropdown-menu .dropdow-notification ul.notification li a {
  color: #4D4F5C;
  font-size: 16px;
  display: block;
  line-height: 32px;
  height: 32px;
  padding: 0 15px;
}

.profile-dropdown .user-link-box ul li a:hover, .profile-dropdown .user-link-box ul li a.activen, .profile-dropdown.dropdown-menu .dropdow-notification ul.notification li:hover {
  text-decoration: none;
  background: #E8E9ED;
}

.profile-dropdown.dropdown-menu .impressonate {
  font-size: 16px;
  font-weight: 600;
  color: #4D4F5C;
  line-height: 16px;
  margin-bottom: 3px;
  padding: 3px 0 0 0;
}

.profile-dropdown.dropdown-menu .imps-user a, .profile-dropdown.dropdown-menu .imps-user a:hover {
  color: #4296F7;
  font-size: 14px;
  text-decoration: underline;
}

.profile-dropdown.dropdown-menu .impressonate label {
  font-weight: 400;
  display: inline-block;
  padding-left: 3px;
  margin: 0;
}

.p-22 {
  padding: 15px !important;
}

.profile-dropdown a.sign-out {
  font-size: 16px;
  color: #4D4F5C;
  line-height: 20px;
  text-decoration: none;
  cursor: pointer;
  display: inline-flex;
}

.profile-dropdown a.sign-out label {
  height: 18px;
  cursor: pointer;
}

.profile-dropdown .sign-out-icon {
  width: 22px;
  margin-right: 6px;
  height: 18px;
  background-size: 100% !important;
  background: url(/assets/images/sign-out-profile.svg) no-repeat 0 0;
  display: inline-block;
}

.profile-dropdown .profile-drop-pic img {
  border-radius: 50%;
  max-width: 47px;
  max-height: 47px;
}

.profile-dropdown.dropdown-menu .dropdow-notification ul li a {
  display: inline-block !important;
  position: relative;
}

.profile-dropdown.dropdown-menu .dropdow-notification ul li a:after {
  width: 8px;
  height: 8px;
  position: absolute;
  right: 0;
  top: 9px;
  border-radius: 50%;
  content: "";
  background: #E04C41;
}

.username {
  color: #43425D;
  font-weight: 600;
  text-decoration: underline;
}

.username img {
  max-width: 40px;
  margin-right: 10px;
  max-height: 40px;
  border-radius: 50%;
}

.profile-dropdown.dropdown-menu {
  top: 65px;
  left: -26px;
}

.profile-dropdown.dropdown-menu {
  padding-bottom: 0;
}

.profile-dropdown.dropdown-menu a.sign-out label {
  margin: 0;
}

.dropdown.user-auth a.username {
  position: relative;
  padding-right: 25px;
}

.dropdown.user-auth a.username:after {
  content: "";
  background: url(/assets/images/small-down-icon.svg) no-repeat 99% 5px;
  position: absolute;
  width: 11px;
  height: 14px;
  right: 8px;
  top: 18px;
  transition: all 0.5s;
}

.dropdown.user-auth.show a.username:after {
  transform: rotate(180deg);
  top: 21px;
}

.site-ellipses {
  white-space: nowrap;
  float: right;
  max-width: 90px;
  text-overflow: ellipsis;
  overflow: hidden;
}

.top-bar .navbar li.user-auth .name::before {
  content: " ";
  height: 10px;
  width: 10px;
  background: #4296F7;
  position: absolute;
  left: 8px;
  border-radius: 50%;
  top: 7px;
}
`, "",{"version":3,"sources":["webpack://./src/app/core/page-header/page-header.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,2CAA2C;EAC3C,SAAS;EACT,gBAAgB;EAChB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,mCAAmC;EACnC,oCAAoC;EACpC,8BAA8B;EAC9B,WAAW;EACX;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,mCAAmC;EACnC,oCAAoC;EACpC,iCAAiC;EACjC,WAAW;EACX;AACF;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,8BAA8B;;AAE9B;EACE,WAAW;EACX,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gCAAgC;EAChC,kEAAkE;EAClE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qEAAqE;EACrE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,QAAQ;AACV","sourcesContent":["::-webkit-scrollbar-track {\n  background: #323e4a;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #1C2A39;\n}\n\n.sidebar-menu-item:hover a i {\n  filter: brightness(158%) sepia(0) hue-rotate(0) saturate(0);\n}\n\n.sidebar-menu-item:hover a span.right-nav-text {\n  color: rgb(235, 235, 235);\n}\n\n.profile-dropdown {\n  width: 216px;\n  position: absolute;\n  left: -64px;\n  background: #fff;\n  border: #D1D3DB solid 1px;\n  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);\n  top: 47px;\n  border-radius: 0;\n  right: 0;\n  margin: 0;\n}\n\n.profile-dropdown .name-box h4 {\n  font-size: 16px;\n  white-space: nowrap;\n  max-width: 107px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  font-weight: 600;\n  color: #43425D;\n  display: inline-block;\n  margin-bottom: 6px;\n  text-decoration: underline;\n  line-height: 20px;\n}\n\n.profile-dropdown .user-info, .profile-dropdown .user-link-box {\n  padding: 15px;\n  border-bottom: #EBEBF2 solid 1px;\n}\n\n.dropdown.user-auth {\n  border-left: none;\n}\n\n.profile-dropdown .btn.view {\n  border: #EBEBF2 solid 1px;\n  width: 90px;\n  height: 28px;\n  border-radius: 0;\n  font-size: 12px;\n  line-height: 28px;\n  padding: 0;\n}\n\n.profile-dropdown .btn.view:focus {\n  outline: none;\n}\n\n.dropdown.user-auth > a {\n  text-decoration: none;\n}\n\n.dropdown.user-auth .user-right-name > label {\n  margin: 0;\n  cursor: pointer;\n  font-size: 16px;\n  text-decoration: underline;\n}\n\n.dropdown.user-auth .user-right-name > .impressonate {\n  font-size: 12px;\n  line-height: 12px;\n  color: #4D4F5C;\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.dropdown.user-auth .user-right-name > .impressonate > label {\n  text-decoration: underline;\n  color: #4296F7;\n  font-size: 12px;\n  display: inline-block;\n  margin: 0;\n}\n\n.profile-dropdown .btn.view .fa.fa-chevron-right {\n  font-size: 10px;\n  color: #A4AFB7;\n  margin: 0 0 0 2px;\n}\n\n.profile-dropdown .user-link-box {\n  padding: 15px 0;\n}\n\n.drop-iner-wrap {\n  position: relative;\n}\n\n.profile-dropdown:before {\n  position: absolute;\n  left: 44%;\n  top: -11px;\n  border-left: 12px solid transparent;\n  border-right: 12px solid transparent;\n  border-bottom: 12px solid #fff;\n  content: \"\";\n  z-index: 9\n}\n\n.profile-dropdown:after {\n  position: absolute;\n  left: 44%;\n  top: -13px;\n  border-left: 12px solid transparent;\n  border-right: 12px solid transparent;\n  border-bottom: 12px solid #D1D3DB;\n  content: \"\";\n  z-index: 1\n}\n\n/*******dropdown pic**********/\n.profile-dropdown.dropdown-menu .dropdow-notification {\n  padding: 15px 0;\n  border-bottom: #EBEBF2 solid 1px;\n}\n\n.dropdown.user-auth .profile-drop-pic.top {\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  border: #8C96A0 solid 3px;\n  overflow: hidden;\n  margin: 10px 5px 5px;\n}\n\n.dropdown.user-auth .profile-drop-pic.top > img {\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n}\n\n.dropdown.user-auth .profile-dropdown .profile-drop-pic {\n  width: 47px;\n  height: 47px;\n  border-radius: 50%;\n  border: #8C96A0 solid 4px;\n  overflow: hidden;\n  margin-top: 5px;\n}\n\n.dropdown.user-auth .profile-dropdown .profile-drop-pic img {\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n}\n\n/*******dropdown pic**********/\n\n.profile-dropdown .user-link-box ul li, .profile-dropdown.dropdown-menu .dropdow-notification ul.notification li {\n  width: 100%;\n  padding: 0;\n  margin: 0;\n  text-align: left;\n  height: auto;\n}\n\n.profile-dropdown .user-link-box ul li a, .profile-dropdown.dropdown-menu .dropdow-notification ul.notification li a {\n  color: #4D4F5C;\n  font-size: 16px;\n  display: block;\n  line-height: 32px;\n  height: 32px;\n  padding: 0 15px;\n}\n\n.profile-dropdown .user-link-box ul li a:hover, .profile-dropdown .user-link-box ul li a.activen, .profile-dropdown.dropdown-menu .dropdow-notification ul.notification li:hover {\n  text-decoration: none;\n  background: #E8E9ED;\n}\n\n.profile-dropdown.dropdown-menu .impressonate {\n  font-size: 16px;\n  font-weight: 600;\n  color: #4D4F5C;\n  line-height: 16px;\n  margin-bottom: 3px;\n  padding: 3px 0 0 0;\n}\n\n.profile-dropdown.dropdown-menu .imps-user a, .profile-dropdown.dropdown-menu .imps-user a:hover {\n  color: #4296F7;\n  font-size: 14px;\n  text-decoration: underline;\n}\n\n.profile-dropdown.dropdown-menu .impressonate label {\n  font-weight: 400;\n  display: inline-block;\n  padding-left: 3px;\n  margin: 0;\n}\n\n.p-22 {\n  padding: 15px !important;\n}\n\n.profile-dropdown a.sign-out {\n  font-size: 16px;\n  color: #4D4F5C;\n  line-height: 20px;\n  text-decoration: none;\n  cursor: pointer;\n  display: inline-flex;\n}\n\n.profile-dropdown a.sign-out label {\n  height: 18px;\n  cursor: pointer;\n}\n\n.profile-dropdown .sign-out-icon {\n  width: 22px;\n  margin-right: 6px;\n  height: 18px;\n  background-size: 100% !important;\n  background: url(/assets/images/sign-out-profile.svg) no-repeat 0 0;\n  display: inline-block;\n}\n\n.profile-dropdown .profile-drop-pic img {\n  border-radius: 50%;\n  max-width: 47px;\n  max-height: 47px;\n}\n\n.profile-dropdown.dropdown-menu .dropdow-notification ul li a {\n  display: inline-block !important;\n  position: relative;\n}\n\n.profile-dropdown.dropdown-menu .dropdow-notification ul li a:after {\n  width: 8px;\n  height: 8px;\n  position: absolute;\n  right: 0;\n  top: 9px;\n  border-radius: 50%;\n  content: \"\";\n  background: #E04C41;\n}\n\n.username {\n  color: #43425D;\n  font-weight: 600;\n  text-decoration: underline;\n}\n\n.username img {\n  max-width: 40px;\n  margin-right: 10px;\n  max-height: 40px;\n  border-radius: 50%;\n}\n\n.profile-dropdown.dropdown-menu {\n  top: 65px;\n  left: -26px;\n}\n\n.profile-dropdown.dropdown-menu {\n  padding-bottom: 0;\n}\n\n.profile-dropdown.dropdown-menu a.sign-out label {\n  margin: 0;\n}\n\n.dropdown.user-auth a.username {\n  position: relative;\n  padding-right: 25px;\n}\n\n.dropdown.user-auth a.username:after {\n  content: \"\";\n  background: url(/assets/images/small-down-icon.svg) no-repeat 99% 5px;\n  position: absolute;\n  width: 11px;\n  height: 14px;\n  right: 8px;\n  top: 18px;\n  transition: all 0.5s;\n}\n\n.dropdown.user-auth.show a.username:after {\n  transform: rotate(180deg);\n  top: 21px;\n}\n\n.site-ellipses {\n  white-space: nowrap;\n  float: right;\n  max-width: 90px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.top-bar .navbar li.user-auth .name::before {\n  content: \" \";\n  height: 10px;\n  width: 10px;\n  background: #4296F7;\n  position: absolute;\n  left: 8px;\n  border-radius: 50%;\n  top: 7px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
